/* src/app/internalinvoice/internalinvoice.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
#fileLoader {
  text-align: center;
}
.ui-inputtext {
  width: 100%;
}
.calenderInputStart {
  width: 40%;
  margin-right: 12%;
  min-width: 70px;
}
.calenderInputEnd {
  width: 40%;
  min-width: 70px;
  margin-right: 8%;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #cc0000;
  height: 36px;
  background: transparent;
  position: relative;
}
.modal {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.08);
  padding: 0;
  max-height: 100%;
  width: auto;
  margin: auto;
  overflow-y: auto;
  border-radius: 2px;
  will-change: top, opacity;
  box-shadow: none;
}
.modal .modal-content {
  padding: 0px;
  top: 80px;
  position: relative;
  padding-bottom: 44px;
}
.modal-header {
  padding: 10px;
  border-bottom: 1px solid #e5e5e5;
  background:
    linear-gradient(
      to right,
      #00569b,
      #00d1e1);
  color: #fff;
}
.close_btn {
  color: white;
  background-color: #00a9ca !important;
  padding: 4px 8px !important;
  border-radius: 100px;
  opacity: 1;
}
.ui-datatable .ui-datatable-data > tr > td {
  padding: .75em;
  background-color: #ffffff !important;
}
.dateRangeFilter {
  border: 1px solid rgba(0, 0, 0, 0.15);
  height: 30px !important;
  background-color: white;
  width: 160px !important;
  font-size: 13px !important;
  font-weight: 400;
  color: #55595c;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
}
.dateRangeFilter:focus {
  border-bottom: 1px solid #26a69a;
  box-shadow: 0 1px 0 0 #26a69a;
  border: 1px solid #66afe9;
}
.round_table td {
  height: auto !important;
  vertical-align: top;
  padding: 10px 20px 10px 0;
}
.round_table td textarea {
  margin-top: 0;
}
.pdf {
  font-size: 26px !important;
  color: #028ba3;
}
.info_icon {
  color: #003992;
  font-size: 16px;
  border: 2px solid #003992;
  padding: 2px 8px;
  border-radius: 30px;
}
.header_bg {
  background: url(/assets/Images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.blw_headermain {
  text-align: left;
  color: #fff;
  padding: 10px 15px 0px 15px;
}
.blw_headermain img {
  float: left;
  padding-right: 10px;
}
.blw_headermain p {
  color: #2a2a2a;
  opacity: 0.8;
}
.round_table {
  width: 100%;
  border: 1px solid #cccccc;
  border-radius: 0px 0px 5px 5px;
}
.round_table tbody tr td:last-child {
  border-radius: 0px 0px 5px 0px;
}
.round_table tbody tr td:last-child {
  border-radius: 0px 0px 5px 0px;
}
.round_table thead tr th {
  border-bottom: 1px solid #d6d6d6;
  padding: 5px;
}
.round_table {
  border-collapse: separate;
  border-spacing: 0;
}
.round_table tr {
  border: 1px solid #d6d6d6;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -o-border-radius: 20px;
  -webkit-border-radius: 10px;
}
.round_table td {
  background-color: #ffffff;
  height: 110px;
}
.round_table tbody tr th:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(1) {
  padding-left: 20px;
}
.internal_main {
  padding: 0px;
}
.checkbox td {
  width: 20px;
}
.order_buttonicon {
  border-radius: 300px;
  background: #009f16 no-repeat left center !important;
  text-transform: capitalize;
  box-shadow: none;
  padding: 0 16px;
  outline: none;
  position: relative;
  top: -2px;
  left: 10px;
  height: 32px;
  line-height: unset;
}
.tab-content > .active {
  display: block;
}
.userbtn_main {
  margin-top: -53px;
  position: absolute;
  right: 0px;
}
.add_internaluserbtn {
  background-color: #4eb700 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.add_internaluserbtn span {
  font-size: 16px;
}
.userlog_btn {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.transaction_btn {
  background-color: #028ba3 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.transaction_btn img {
  float: none;
  padding: 0px;
}
.external_userlog_btn {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.external_add_internaluserbtn {
  background-color: #4eb700 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.bulk_upload {
  background-color: #009f16 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.external_userlog_btn img {
  float: none;
  padding: 0px;
}
.userlog_btn img {
  float: none;
  padding: 0px;
}
.round_table tbody .last_row td:last-child {
}
.round_table tbody .last_row td:first-child {
}
#exTab1 .tab-content {
  color: #000000;
  padding: 0px;
  border-radius: 10px;
}
#exTab1 .nav-pills > li > a {
  border-radius: 0;
}
td,
th {
  white-space: nowrap;
  padding: 1px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
.nav_main {
  float: left;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #cccccc;
  margin-bottom: 15px;
}
.nav-pills > li > a {
  border-radius: 30px !important;
  color: #000000;
  padding: 10px 36px;
}
.nav-pills > li > a:hover {
  background-color: #ffffff !important;
}
.nav-pills > li.active > a {
  color: #fff;
  background-color: #003992 !important;
}
.edit_icon {
  float: right;
  background-color: #009f16;
  color: #ffffff;
  padding: 10px;
  border-radius: 30px;
  font-weight: bold;
}
.form-group {
  padding: 0px !important;
  margin: 0px !important;
}
.input-field label {
  font-size: 11px;
  padding-left: 5px;
  color: #8bd0f3 !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #fff;
  padding-left: 5px;
  height: 36px;
  background: transparent;
}
textarea {
  height: 72px;
  border-radius: 4px;
  border: 1px solid #cecece;
  margin-top: 4px;
  resize: none;
}
.pay_now {
  padding: 10px 0px;
  float: right;
}
.submit_btn {
  background-color: #009f16 !important;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
input:not([type]),
input[type=text],
input[type=password],
input[type=email],
input[type=url],
input[type=time],
input[type=date],
input[type=datetime],
input[type=datetime-local],
input[type=tel],
input[type=number],
input[type=search],
textarea.materialize-textarea {
  border: 1px solid #dedede;
  height: 34px;
  width: 100%;
  font-size: 1rem;
  margin: 0px;
  padding: 0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px;
}
input:focus {
  outline: none !important;
  border-color: #cccccc;
  box-shadow: none !important;
}
[type=checkbox]:not(:checked),
[type=checkbox]:checked {
  position: absolute;
  left: 0px;
  opacity: 1;
}
.checkbox input[type=checkbox],
.checkbox-inline input[type=checkbox],
.radio input[type=radio],
.radio-inline input[type=radio] {
  margin-left: 0px;
  font-size: 20px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu > li > a:hover {
  background-color: #008ad0;
  color: #ffffff;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.searchmain {
  margin: 0;
  position: relative;
  text-align: right;
  padding: 30px 30px 30px 0px;
}
.search_box {
  width: 415px !important;
  margin-bottom: 10px !important;
  margin-left: 5px !important;
  background-color: #fdfdfd !important;
  height: 33px !important;
  padding-right: 50px;
}
.search_icon {
  padding: 10px 10px 8px 11px;
  background-color: #028ba3 !important;
  color: #ffffff !important;
  position: absolute;
  width: 30px;
  height: 33px;
}
.advancePaymentTbl th,
.advancePaymentTbl td {
  padding: 10px 15px !important;
}
@media (min-width: 300px) and (max-width: 600px) {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #505050;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #b30000;
  }
  .logo {
    text-align: left;
    color: #fff;
    padding: 25px 14px 0px 25px;
  }
  .user_main {
    float: right;
    text-align: right;
    color: white;
    border-left: solid 1px rgba(0, 0, 0, 0.2);
    padding: 15px 28px 7px 0px;
    margin-left: 0px;
  }
  .nav_main {
    float: left;
    background-color: #ffffff;
    border-radius: 30px;
    border: 1px solid #cccccc;
    margin-bottom: 60px;
  }
  .nav-pills > li > a {
    padding: 10px 10px;
  }
  .userbtn_main {
    margin-top: -48px;
    left: 0px;
  }
  .add_internaluserbtn {
    margin-top: 10px;
  }
  .userbtn_main img {
    float: right;
    padding: 4px 0px 0px 4px;
  }
  .external_userlog_btn img {
    float: none;
    padding: 0px !important;
  }
  .modal .modal-content {
    overflow-x: scroll;
  }
  .modal-header h5 {
    white-space: normal;
  }
  .pay_now {
    padding: 10px;
    float: left;
  }
  .search_box {
    width: 90% !important;
  }
  .search_icon {
    padding: 10px 10px 9px 12px;
  }
  .round_table tbody tr td:last-child {
    padding-bottom: 50px;
    padding-top: 10px;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .userbtn_main {
    margin-top: -60px;
    position: absolute;
    left: 0px;
  }
  .nav_main {
    margin-bottom: 60px;
  }
  .external_add_internaluserbtn {
    margin-top: 0px;
  }
  .bulk_upload {
    margin-top: 0px;
  }
  .add_internaluserbtn {
    margin-top: 0px;
  }
  .modal .modal-content {
    overflow-x: scroll;
  }
}
.agencyCont {
  float: left;
  margin-right: 15px;
}
@media only screen and (max-width: 800px) {
  .no-more-tables table,
  \a0  .no-more-tables thead,
  \a0  .no-more-tables tbody,
  .no-more-tables th,
  \a0  .no-more-tables td,
  .no-more-tables tr {
    display: block;
  }
  .no-more-tables thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .no-more-tables tr {
    border: 1px solid #ccc;
  }
  .no-more-tables td {
    padding-left: 40% !important;
    border: none;
    position: relative;
    border-bottom: 1px solid #eee;
    white-space: normal;
    text-align: left;
  }
  .no-more-tables td:before {
    text-align: left;
    font-weight: bold;
    white-space: nowrap;
    position: absolute;
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 0px;
  }
  .no-more-tables td:before {
    content: attr(data-title);
  }
}
@media screen and (max-width: 800px) {
  .advancePaymentTbl tbody td::before {
    white-space: normal !important;
    width: 38% !important;
  }
  #accountExecutiveDD {
    padding-bottom: 20px;
  }
  #accountExecutiveDD .ui-dropdown .ui-dropdown-label {
    white-space: normal !important;
    line-height: 19px;
    height: 30px;
  }
}
/*# sourceMappingURL=internalinvoice.component.css.map */
